"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
function enumNames(enumType) {
    return Object.keys(enumType).filter(function (x) { return _.isNumber(enumType[x]); });
}
exports.enumNames = enumNames;
function enumStringMap(enumType) {
    return _.object(enumNames(enumType).map(function (x) { return [x, x]; }));
}
exports.enumStringMap = enumStringMap;
//# sourceMappingURL=enumHelpers.js.map